import { UseDisclosureReturn } from '@chakra-ui/react';
import { BaseDialog } from '@cks-internal/react-base';
import { VirtualCardTransactionDisplay } from '../../../features/activities/virtualCards/VirtualCardTransactionDisplay.tsx';
import { useState } from 'react';
import { useSystemSettingByKeyQuery } from 'src/util/systemSettings/useSystemSettingByKeyQuery.ts';
import { VccAllowedMccCodesKey } from 'src/constants/systemSettingKeys.ts';

type Props = {
  disclosure: UseDisclosureReturn;
  activityId: number;
  viewingCardId: string | undefined;
};

export const VirtualCardTransactionsDialog = ({ disclosure, viewingCardId, activityId }: Props) => {
  const mccCodesString = useSystemSettingByKeyQuery(VccAllowedMccCodesKey).data;
  const [height, setHeight] = useState(500);
  return (
    <BaseDialog
      disclosure={disclosure}
      dragDialog={{ initialH: 500, initialW: 1200, onResize: (_, h) => setHeight(h) }}
      header='Virtual Card Transactions'>
      <b>{mccCodesString?.StringValue}</b>
      {viewingCardId && (
        <VirtualCardTransactionDisplay tableHeight={height - 220} activityId={activityId} cardId={viewingCardId} />
      )}
    </BaseDialog>
  );
};
